import apiClient from 'api/apiClient';
import { Category } from 'model/Category';

export const getAllCategories = async (): Promise<Category[]> => {
  const response = await apiClient.get('/v1/categories');
  return response?.data;
};
